







import { Component, Vue, Prop } from 'vue-property-decorator';
import ProjectIssuesList from '@/components/ProjectIssuesList.vue';
import NotLoggedPanel from '@/components/NotLoggedPanel.vue';
import { User } from '@/models/user';

@Component({
    name: 'ProjectIssues',
    components: {
        ProjectIssuesList,
        NotLoggedPanel
    }
})
export default class ProjectIssues extends Vue {
    @Prop() private user!: User;
}
